import Tabs from "@/components/Tabs";
import { useCanViewOperationsTabBool } from "@/hooks/useCapabilities";
import { Path, useNavigate } from "@/router";
import { useLocation } from "react-router-dom";

function normalizePathname(pathname: string): string {
  if (pathname.length > 1 && pathname.endsWith("/")) {
    return pathname.slice(0, -1);
  }
  return pathname;
}

export default function PeopleTabs() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const showOperationsTab = useCanViewOperationsTabBool();
  const path = normalizePathname(pathname);

  const tabItems = [
    {
      label: "All People",
      to: "/people" as Path,
      active: path === "/people"
    },
    ...(showOperationsTab
      ? [
          {
            label: "Operations",
            to: "/people/membership-services" as Path,
            active: path.startsWith("/people/membership-services")
          }
        ]
      : [])
  ].map(({ label, to, active }) => ({
    label,
    onClick: () => navigate(to),
    active
  }));

  return <Tabs tabItems={tabItems} />;
}
